<div class="scaffold-email">
  <input [(ngModel)]="subject" pInputText [placeholder]="'subject'| translation" />
  <textarea [(ngModel)]="body" pTextarea [placeholder]="'message'| translation"></textarea>
  <button
    [disabled]="!subject || !body"
    severity="warn"
    (click)="sendEmail()"
    pButton
    [loading]="isSending"
  >
    <span>{{'send_message'| translation}}</span>
  </button>
</div>
